export default {"src":"/_next/static/media/secondary_copy.29b98ce3.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};